// Allow global access (using webpack externals)
// see vendors.json for details
(window as any).dormakaba.vendorReact = (window as any).dormakaba.vendorReact || {};

if (!(window as any).dormakaba.vendorReact.hasOwnProperty('vendor/mobx-react')) {
	Object.defineProperty((window as any).dormakaba.vendorReact, 'vendor/mobx-react', {
		value: require('mobx-react'),
		writable: false,
		enumerable: false,
		configurable: false,
	});
}
